<div class="detail-page-container">
  <!-- Page Header -->
  <div class="edit-header">
    <div class="edit-header-left">
      <button
        class="back-btn"
        (click)="goBack()"
        aria-label="Go back"
        type="button"
      >
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M19 12H5M12 19l-7-7 7-7"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <div class="edit-header-titles">
        <h1 class="edit-title">{{ pageTitle }}</h1>
        @if (pageDescription) {
          <p class="edit-subtitle">{{ pageDescription }}</p>
        }
      </div>
    </div>
  </div>

  <div class="detail-page-content">
    @if (isLoading) {
      <div class="loading-state">
        <div class="spinner"></div>
        <p>Loading your information...</p>
      </div>
    } @else {
      <!-- Dynamic form component based on product type -->
      @switch (productType) {
        @case ("loans-capital") {
          <app-business-loan-form
            #dynamicForm
            [initialValue]="initialFormData"
            [creditScoreRange]="additionalInputs.creditScoreRange"
            (formSubmit)="onFormSubmit($event)"
          ></app-business-loan-form>
        }
        @case ("technical-assistance") {
          <app-technical-assistance-form
            #dynamicForm
            [initialValue]="initialFormData"
            (formSubmit)="onFormSubmit($event)"
          ></app-technical-assistance-form>
        }
        @case ("operational-tools") {
          <app-operational-tools-form
            #dynamicForm
            [initialValue]="initialFormData"
            (formSubmit)="onFormSubmit($event)"
          ></app-operational-tools-form>
        }
        @case ("real-estate") {
          <app-real-estate-form
            #dynamicForm
            [initialValue]="initialFormData"
            (formSubmit)="onFormSubmit($event)"
          ></app-real-estate-form>
        }
        @case ("solar-energy") {
          <app-solar-energy-form
            #dynamicForm
            [initialValue]="initialFormData"
            [creditScoreRange]="additionalInputs.creditScoreRange"
            (formSubmit)="onFormSubmit($event)"
          ></app-solar-energy-form>
        }
        @case ("finding-investors") {
          <app-finding-investors-form
            #dynamicForm
            [initialValue]="initialFormData"
            (formSubmit)="onFormSubmit($event)"
          ></app-finding-investors-form>
        }
      }
    }
  </div>

  @if (!isLoading) {
    <div class="detail-page-footer">
      @if (dynamicForm?.hasErrors) {
        <div class="footer-error-banner" role="alert">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="2"
            />
            <path
              d="M12 8v4M12 16h.01"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          <span>Please fix the highlighted errors above before saving.</span>
        </div>
      }
      <div class="form-actions">
        <button
          class="cancel-btn"
          (click)="goBack()"
          [disabled]="isSaving"
          type="button"
        >
          Cancel
        </button>
        <button
          class="save-btn"
          [disabled]="isSaving"
          (click)="onSubmit()"
          type="button"
        >
          @if (isSaving) {
            <span class="spinner"></span>
            Saving…
          } @else {
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 13l4 4L19 7"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Save
          }
        </button>
      </div>
    </div>
  }
</div>
